export function getIdentifier(value: string): string {
  if (value.indexOf(":") > 0) {
    return value.substring(value.indexOf(":") + 1, value.indexOf("-")).toUpperCase();
  }
  return value.substring(0, 8).toUpperCase();
}
